export class BillingAddress {
    id?: number;
    street?: string;
    type?: string;
    country?: string;
    city?: string;
    state?: any;
    zipcode?: number;
    stateId?: number;
    accountId?: number;
    suiteNumber?: string;
    landmark?:string;
    address?:string;
    contactId?:any
}
